module.exports = __webpack_public_path__ + "static/img/logo.a3ece97d.png";